import { CardMedia, CircularProgress, Grid, InputAdornment, Theme } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { MFTextField } from '../../lib/formik';
import { Formik, FormikHandlers, FormikHelpers, FormikProps, validateYupSchema, yupToFormErrors } from "../../lib/formik/Formik";
import MFCheckbox from '../../lib/formik/Checkbox';
import {
  allowOnlyNumbers,
  applicationComparison,
  applyRoleBasedStatus,
  getAddressData,
  getAddressFields,
  getApplicantName,
  preventSpecialCharacters,
  saveForLater,
  _updatedAddresses,
  checkForCorrespondenceAddress,
  removeSingleQuote,
  getEmailPhonePersonRelationType,
  isModuleAllowed,
} from '../../utils/utilityFunctions';
import { ApplicantAddressType, ApplicationProps, GetDataForKycModificationResponseBody, KycDetails, MfuKycModificationResponseBody, MfuKycOnboardingResponseBody } from '../../redux-store/types/api-types';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { contactDetailsSchema } from '../../utils/schema';
import {
  APPLICATION_TYPE,
  USER_ROLES,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  applicantStatusMasters,
  applicantStatusValueMap,
  ENABLE_EMAIL_OTP,
  ContactRelations,
} from '../../utils/constant';
import { CountryCodesDropDown } from '../commonComponents';
import { getNationalityList } from '../../redux-store/actions';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import { useSnackbar } from 'notistack';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import UseRadioGroup from '../../lib/formik/Radio';
import MFSelectField from '../../lib/formik/SelectField';
import { LoadingButton } from '@mui/lab';
import { getDataForKycModification, MfuKycModification } from '../../redux-store/actions/onBoarding';
import KycEditPopup from '../onboarding/KycEditPopup';
import KycInfoPopup from '../onboarding/KycInfoPopup';

type ContactDetailsProps = {
  id?: string;
  panNo: string;
  name: string;
  dateOfBirth: string | null;
  applicationId?: number | null;
  phoneNumberoffice: string;
  phoneNumberResidence: string;
  email: string;
  mobile: string;
  countryNameAndCode: string;
  countryCode: string;
  address: {
    nationality?: string | null;
    status?: string | null;
    applicantStatus?: string | null;
    permanent?: Partial<ApplicantAddressType>;
    correspondence?: Partial<ApplicantAddressType>;
    overseas?: Partial<ApplicantAddressType>;
    [key: string]: Partial<ApplicantAddressType> | string | null | undefined;
  };
  kraMobileNumber: string;
  kraEmailId: string;
  emailPersonRelation: string;
  emailPersonRelationType: string;
  phonePersonRelation: string;
  phonePersonRelationType: string;
};

export type Values = {
  hasPOA: boolean;
  applicants: ContactDetailsProps[];
  saveType: string;
  countryDropdown: string[];
  [key: string]: string | boolean | ContactDetailsProps[] | string[];
};

const initialValues: Values = {
  hasPOA: false,
  applicants: [
    {
      id: "",
      panNo: "",
      name: "",
      dateOfBirth: "",
      applicationId: null,
      phoneNumberoffice: '',
      phoneNumberResidence: '',
      email: '',
      mobile: '',
      countryNameAndCode: 'India: +91',
      countryCode: '+91',
      address: {
        nationality: null,
        status: null,
        applicantStatus: null,
        permanent: getAddressFields('permanent'),
        correspondence: getAddressFields('correspondence'),
        overseas: getAddressFields('overseas'),
      },
      kraMobileNumber: '',
      kraEmailId: '',
      emailPersonRelation: '',
      emailPersonRelationType: '',
      phonePersonRelation: '',
      phonePersonRelationType: '',
    },
  ],
  saveType: 'save and proceed',
  countryDropdown: [],
};

export const Address = ({
  addressType = '',
  index,
  nationalitiesMdmsResponse,
  fetchedFromKRACheck,
  isStatusIndividual = true
}: {
  addressType: string;
  index: number;
  nationalitiesMdmsResponse: mdmsCountriesList[];
  fetchedFromKRACheck: boolean | null;
  isStatusIndividual?: boolean;
}): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const isFieldDisabled =
    (['overseas'].includes(addressType) &&
      [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)) ||
    (!['permanent', 'correspondence'].includes(addressType) && fetchedFromKRACheck) ||
    false;
  return (
    <>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.address1`}
          label={`Address Line 1*`}
          placeholder="Enter Address Line 1"
          // disabled={isFieldDisabled}
          disabled={addressType === "permanent"}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.address2`}
          label={`Address Line 2${!fetchedFromKRACheck || (fetchedFromKRACheck && addressType !== 'permanent') ? '*' : ''
            }`}
          placeholder="Enter Address Line 2"
          // disabled={isFieldDisabled}
          disabled={addressType === "permanent"}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.address3`}
          label={`Address Line 3`}
          placeholder="Enter Address Line 3"
          // disabled={isFieldDisabled}
          disabled={addressType === "permanent"}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.pincode`}
          label={`PIN Code*`}
          placeholder="Enter Pincode"
          // disabled={isFieldDisabled}
          disabled={addressType === "permanent"}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.city`}
          label={`City*`}
          placeholder="Enter City"
          // disabled={isFieldDisabled}
          disabled={addressType === "permanent"}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.state`}
          label={`State*`}
          placeholder="Enter State"
          // disabled={isFieldDisabled}
          disabled={addressType === "permanent"}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        {/* {!nationalitiesMdmsResponse && (
          <MFTextField
            name={`applicants.${index}.address.${addressType}.country`}
            label={`Country *`}
            placeholder="Enter Country"
            disabled={isFieldDisabled}
          />
        )} */}
        {/* {nationalitiesMdmsResponse && ( */}
        <SearchableSelect
          name={`applicants.${index}.address.${addressType}.country`}
          label="Country*"
          items={nationalitiesMdmsResponse.map((nationality) => ({
            key: nationality.name,
            value: nationality.name,
          }))}
          // disabled={
          //   isFieldDisabled ||
          //   (addressType === "permanent" && !isStatusIndividual)
          // }
          disabled={addressType === "permanent"}
          searchFieldPlaceholder={'Search Country'}
        />
        {/* )} */}
      </Grid>
    </>
  );
};

const ApplicantDetails = ({
  values,
  handleChange,
  setValues,
  mdmsCountriesList,
  application,
  setSelectedApplicantId,
  handleEditKycClick,
  isEditKycLoading
}: {
  values: Values;
  handleChange: FormikHandlers['handleChange'];
  setValues: FormikHelpers<Values>['setValues'];
  mdmsCountriesList: mdmsCountriesList[];
  application: ApplicationProps | null;
  setSelectedApplicantId: React.Dispatch<React.SetStateAction<number | null>>;
  handleEditKycClick: ({ applicationId, applicantId, panNo }: {
    applicationId: number | null | undefined;
    applicantId: string;
    panNo: string;
  }) => void;
  isEditKycLoading: boolean;
}): JSX.Element => {
  const { path: currentPath } = useRouteMatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  useEffect(() => {
    const mobileElement = document.getElementsByName('applicants.0.countryNameAndCode');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);

  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")

  const isDigitalOnboarding = `${application?.onboardingVia ?? ""}`.toLowerCase() === "digital"

  return (
    <React.Fragment>
      {values.applicants.map((applicant, index) => (
        <React.Fragment key={index}>
          <Grid item xs={12}>
            <SubHeading
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: "10px 15px"
              }}
            >
              Contact details of {getApplicantName(index + 1)} Applicant
              <LoadingButton
                variant="outlined"
                onClick={() => {
                  setSelectedApplicantId(Number(applicant?.id ?? ""))
                  handleEditKycClick({
                    applicationId: applicant?.applicationId,
                    applicantId: applicant?.id ?? "",
                    panNo: applicant?.panNo ?? ""
                  })
                }}
                loading={isEditKycLoading}
                loadingIndicator={
                  <CircularProgress
                    size={18}
                    sx={(theme: Theme) => ({ color: theme.palette.primary[500] })} />
                }
                sx={(theme: Theme) => ({
                  ...theme.typography.body_500,
                  fontWeight: 600,
                  color: theme.palette.primary[500],
                  padding: '5px',
                })}
              >
                Edit KYC
              </LoadingButton>
            </SubHeading>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`applicants.${index}.email`}
              label="Email ID*"
              placeholder="Enter E-Mail ID"
              // readOnly={values.hasPOA ? false : true && ENABLE_EMAIL_OTP}
              // startAdornment={
              //   <InputAdornment position="start">
              //     <CardMedia component="img" alt="Email Icon" src="/images/email.svg" />
              //   </InputAdornment>
              // }
              // disabled={
              //   isDiyInvestorOnboarding ? false :
              //     ((!application?.editable && USER_ROLES.INVESTOR !== role) ||
              //       (USER_ROLES.INVESTOR === role && index !== 0))
              // }
              disabled={isDigitalOnboarding}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFSelectField
              name={`applicants.${index}.emailPersonRelationType`}
              label="This Email ID belongs to?*"
              items={Object.keys(ContactRelations).map((relation) => ({
                key: ContactRelations[relation],
                value: relation,
              }))}
              onChange={(e) => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((_applicant, _index) => {
                    if (_index === index) {
                      return {
                        ..._applicant,
                        emailPersonRelationType: e.target.value,
                        emailPersonRelation: e.target.value === 'Others' ? '' : e.target.value,
                      };
                    }
                    return _applicant;
                  }) as ContactDetailsProps[],
                });
              }}
            />
          </Grid>
          <Grid container xs={12}>
            {values.applicants.map((applicant, idx: number) => {
              if (applicant.emailPersonRelationType === 'Others' && idx === index) {
                return (
                  <Grid item xs={12} lg={6} key={idx}>
                    <MFTextField

                      name={`applicants.${index}.emailPersonRelation`}
                      label="Please Specify Relationship*"
                      placeholder={`Enter Relationship`}
                    />
                  </Grid>
                );
              }
            })}
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`applicants.${index}.mobile`}
              label="Mobile Number*"
              placeholder="Enter Mobile Number"
              onKeyDown={(e) => {
                preventSpecialCharacters(e);
              }}
              // readOnly={values.hasPOA ? false : true}
              startAdornment={
                <CountryCodesDropDown
                  ElementWidth={mobileElementWidth && mobileElementWidth}
                  name={`applicants.${index}.countryNameAndCode`}
                  value={values.applicants[index].countryNameAndCode}
                  // readOnly={values.hasPOA ? false : true}
                  // disabled={[USER_ROLES.INVESTOR].includes(role)}
                  // disabled={
                  //   isDiyInvestorOnboarding ? false :
                  //     ((!application?.editable && USER_ROLES.INVESTOR !== role) ||
                  //       (USER_ROLES.INVESTOR === role && index !== 0))
                  // }
                  disabled={isDigitalOnboarding}
                />
              }
              // disabled={[USER_ROLES.INVESTOR].includes(role)}
              // disabled={
              //   isDiyInvestorOnboarding ? false :
              //     ((!application?.editable && USER_ROLES.INVESTOR !== role) ||
              //       (USER_ROLES.INVESTOR === role && index !== 0))
              // }
              disabled={isDigitalOnboarding}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFSelectField
              name={`applicants.${index}.phonePersonRelationType`}
              label="This Mobile Number belongs to?*"
              items={Object.keys(ContactRelations).map((relation) => ({
                key: ContactRelations[relation],
                value: relation,
              }))}
              onChange={(e) => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((_applicant, _index) => {
                    if (_index === index) {
                      return {
                        ..._applicant,
                        phonePersonRelationType: e.target.value,
                        phonePersonRelation: e.target.value === 'Others' ? '' : e.target.value,
                      };
                    }
                    return _applicant;
                  }) as ContactDetailsProps[],
                });
              }}
            />
          </Grid>
          <Grid container xs={12}>
            {values.applicants.map((applicant, idx: number) => {
              if (applicant.phonePersonRelationType === 'Others' && idx === index) {
                return (
                  <Grid item xs={12} lg={6} key={idx}>
                    <MFTextField

                      name={`applicants.${index}.phonePersonRelation`}
                      label="Please Specify Relationship*"
                      placeholder={`Enter Relationship`}
                    />
                  </Grid>
                );
              }
            })}
          </Grid>
          {/* {applicant.kraMobileNumber && ( */}
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`applicants.${index}.kraMobileNumber`}
              label={`KRA Mobile Number`}
              placeholder="Enter KRA Mobile Number"
              disabled
            />
          </Grid>
          {/* )} */}
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`applicants.${index}.kraEmailId`}
              label={`KRA Email Id`}
              placeholder="Enter KRA Email Id"
              disabled
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`applicants.${index}.phoneNumberoffice`}
              label="Phone (Office)"
              placeholder="Enter Phone (Office)"
              onChange={handleChange}
              type="number"
              onKeyDown={(e) => {
                allowOnlyNumbers(e);
              }}
              trimOnBlur={false}
            // startAdornment={
            //   <InputAdornment position="start">
            //     <CardMedia component="img" alt="Phone Icon" src="/images/phone.svg" />
            //   </InputAdornment>
            // }
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`applicants.${index}.phoneNumberResidence`}
              label="Phone (Residential)"
              placeholder="Enter Phone (Residential)"
              type="number"
              onKeyDown={(e) => {
                allowOnlyNumbers(e);
              }}
              trimOnBlur={false}
            // startAdornment={
            //   <InputAdornment position="start">
            //     <CardMedia component="img" alt="Phone Icon" src="/images/phone.svg" />
            //   </InputAdornment>
            // }
            />
          </Grid>
          {/* {applicant.address.nationality?.toLowerCase() !== 'indian' && (
            <React.Fragment>
              <SubHeading>Overseas Address of {getApplicantName(index + 1)} Applicant</SubHeading>
              <Address
                addressType={'overseas'}
                index={index}
                nationalitiesMdmsResponse={mdmsCountriesList}
              />
            </React.Fragment>
          )} */}
          {checkForCorrespondenceAddress(
            applicant.address.applicantStatus || ''
          ) ? (
            <>
              <Grid item xs={12}>
                <SubHeading>
                  Correspondence Address of {getApplicantName(index + 1)} Applicant
                </SubHeading>
              </Grid>
              <Address
                addressType={'correspondence'}
                index={index}
                nationalitiesMdmsResponse={mdmsCountriesList}
                key={values.applicants.length}
                fetchedFromKRACheck={applicant.address.correspondence?.fetchedFromKRA || null}
              />
            </>
          ) : (
            <React.Fragment>
              <Grid item xs={12}>
                <SubHeading>Overseas Address of {getApplicantName(index + 1)} Applicant</SubHeading>
              </Grid>
              <Address
                addressType={'overseas'}
                index={index}
                nationalitiesMdmsResponse={mdmsCountriesList}
                fetchedFromKRACheck={applicant.address.overseas?.fetchedFromKRA || null}
              />
            </React.Fragment>
          )}
          {(
            applicant.address.nationality &&
            !applicant.address.permanent?.fetchedFromKRA &&
            !applicant.address.correspondence?.fetchedFromKRA &&
            !applicant.address.overseas?.fetchedFromKRA &&
            applicantStatusMasters[applicant.address.status as string] === applicantStatusMasters.Individual
          ) && (
              <Grid item container xs={12} lg={6} alignItems="center">
                <MFCheckbox
                  onChange={({ target: { checked } }) =>
                    setValues({
                      ...values,
                      applicants: values.applicants.map((_applicant, _index) => {
                        if (_index === index) {
                          return {
                            ..._applicant,
                            address: checkForCorrespondenceAddress(
                              _applicant.address.applicantStatus || ''
                            )
                              ? {
                                ..._applicant.address,
                                correspondence: {
                                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                  ..._applicant.address.correspondence!,
                                  permanentAddressSameAsCorresponding: checked,
                                },
                                ...(!checked && { permanent: getAddressFields('permanent') }),
                              }
                              : {
                                ..._applicant.address,
                                overseas: {
                                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                  ..._applicant.address.overseas!,
                                  permanentAddressSameAsCorresponding: checked,
                                },
                                ...(!checked && { permanent: getAddressFields('permanent') }),
                              },
                          };
                        }
                        return _applicant;
                      }),
                    })
                  }
                  name={`applicants.${index}.address.${checkForCorrespondenceAddress(
                    applicant.address.applicantStatus || ''
                  )
                    ? 'correspondence'
                    : 'overseas'
                    }.permanentAddressSameAsCorresponding`}
                  label={
                    checkForCorrespondenceAddress(
                      applicant.address.applicantStatus || ''
                    )
                      ? 'Permanent address same as correspondence address.'
                      : 'Permanent address same as overseas address.'
                  }
                  // sx={{ ml: '40px' }}
                  disabled={isDiyInvestorOnboarding ? false : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)}
                />
              </Grid>
            )}
          {(checkForCorrespondenceAddress(
            applicant.address.applicantStatus || ''
          )
            ? !values.applicants[index]?.address?.correspondence
              ?.permanentAddressSameAsCorresponding
            : !values.applicants[index]?.address?.overseas
              ?.permanentAddressSameAsCorresponding) && (
              <>
                <Grid item xs={12}>
                  <SubHeading>Permanent Address of {getApplicantName(index + 1)} Applicant</SubHeading>
                </Grid>
                <Address
                  addressType={'permanent'}
                  index={index}
                  nationalitiesMdmsResponse={mdmsCountriesList}
                  fetchedFromKRACheck={applicant.address.permanent?.fetchedFromKRA || null}
                  isStatusIndividual={applicantStatusMasters[applicant.address.status as string] === applicantStatusMasters.Individual}
                />
              </>
            )}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

export default function ContactDetails(): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);
  const [contactDetails, setContactDetails] = useState(initialValues);
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const [loading, setLoading] = useState(false);
  const [isEditKycLoading, setEditKycLoading] = useState<boolean>(false)
  const [kycData, setKycData] = useState<KycDetails & {
    isNameChecked: boolean;
    isEmailChecked: boolean;
    isMobileChecked: boolean;
    isAddressChecked: boolean;
  } | null>(null)
  const [selectedApplicantId, setSelectedApplicantId] = useState<number | null>(null)
  const [isKycEditPopupOpen, setKycEditPopupOpen] = useState<boolean>(false)
  const [kycLinkLoading, setKycLinkLoading] = useState<boolean>(false)
  const [kycLinkData, setKycLinkData] = useState<MfuKycOnboardingResponseBody | null>(null)
  const [kycLinkPopupOpen, setKycLinkPopupOpen] = useState<boolean>(false)

  const { enqueueSnackbar } = useSnackbar();
  const { path: currentPath } = useRouteMatch();

  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application")

  const formikRef = useRef<FormikProps<Values>>(null);

  const handleSubmit = async (values: Values) => {
    try {
      const {
        applicants = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      const { saveType = '' } = values;
      const updatePayload = applicants
        .map((applicant, index: number) => {
          const {
            address: updatedAddresses = {},
            emailPersonRelationType,
            phonePersonRelationType,
            ...rest
          } = values.applicants[index] || {};
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { nationality, status, ...addressProps } = updatedAddresses;
          const applicantStatus = applicant.applicantStatus;
          return {
            ...applicant,
            ...rest,
            email: removeSingleQuote(rest.email),
            countryCode: rest.countryNameAndCode?.split(':')[1].trim(),
            addresses:
              !checkForCorrespondenceAddress(applicantStatus) &&
                applicant.addresses?.map((address) => address.address_type).includes('correspondence')
                ? [
                  ..._updatedAddresses(updatedAddresses, applicant),
                  {
                    ...getAddressData('correspondence', applicant.addresses),
                    isActive: false,
                    address_type: 'correspondence',
                  },
                ]
                : checkForCorrespondenceAddress(applicantStatus) &&
                  applicant.addresses?.map((address) => address.address_type).includes('overseas')
                  ? [
                    ..._updatedAddresses(updatedAddresses, applicant),
                    {
                      ...getAddressData('overseas', applicant.addresses),
                      isActive: false,
                      address_type: 'overseas',
                    },
                  ]
                  : _updatedAddresses(updatedAddresses, applicant),
            emailPersonRelation: getEmailPhonePersonRelationType(rest.emailPersonRelation)
              ? emailPersonRelationType
              : removeSingleQuote(rest.emailPersonRelation),
            phonePersonRelation: getEmailPhonePersonRelationType(rest.phonePersonRelation)
              ? phonePersonRelationType
              : removeSingleQuote(rest.phonePersonRelation),
          };
        })
        .map((_applicant) => {
          return {
            ..._applicant,
            addresses: _applicant.addresses.map((address) => {
              return {
                ...address,
                address1: removeSingleQuote(address.address1),
                address2: removeSingleQuote(address.address2),
                address3: removeSingleQuote(address.address3),
                city: removeSingleQuote(address.city),
                state: removeSingleQuote(address.state),
              };
            }),
          };
        });
      const checkApplication = applicationComparison(
        {
          ...application,
          applicants: application?.applicants
            ?.map((applicant) => {
              return {
                ...applicant,
                addresses: applicant.addresses?.sort(
                  (address1, address2) => Number(address1.id) - Number(address2.id)
                ),
              };
            })
            .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
        },
        {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          ...application!,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          applicants: updatePayload
            .map((applicant) => {
              return {
                ...applicant,
                addresses: applicant?.addresses?.sort(
                  (address1, address2) => Number(address1.id) - Number(address2.id)
                ),
              };
            })
            .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
          currentStep: !!currentStep && currentStep > 3 ? currentStep : Number(currentStep) + 1,
        }
      );
      const isSaveLater = saveType !== 'save and proceed';

      let currentStatus = status

      if (
        !isModuleAllowed({ value: (role ?? ""), compareArr: [USER_ROLES.AMCAPPROVER] }) &&
        status === 'sent_to_amc_approver'
      ) {
        currentStatus = 'draft'
      } else if (
        !hasPOA &&
        AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
        status !== 'draft' &&
        applyRoleBasedStatus(role)
      ) {
        currentStatus = 'sent_to_amc_approver'
      }

      if (id && !checkApplication) {
        setLoading(true);
        const response = await dispatch(
          updateApplication({
            body: {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              ...application!,
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              applicants: updatePayload!,
              status: currentStatus,
              currentStep: 4,
              //!!currentStep && currentStep > 2 ? currentStep : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && {
              toastMessage: '',
            }),
          })
        );

        if (Object.keys(response ?? {}).length) {
          !isSaveLater
            ? history.push('additional-KYC-details', { id, applicant1ReferenceId })
            : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
        }

      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? history.push('additional-KYC-details', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
    finally {
      setLoading(false);
    }
  };
  // useEffect(() => {
  //   (async function () {
  //     try {
  //       const nationalitiesMdmsMasters = (await dispatch(
  //         getNationalityList()
  //       )) as unknown as nationaliyType;
  //       setMdmsCountriesList(nationalitiesMdmsMasters.countries);
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   })();
  // }, []);
  useEffect(() => {
    const { applicants: exisitingApplicants = [], hasPOA = false } = application || {};
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        setContactDetails({
          ...contactDetails,
          hasPOA,
          applicants:
            exisitingApplicants?.length === 0
              ? exisitingApplicants.map((applicant) => {
                const {
                  id = '',
                  panNo = '',
                  name = '',
                  dateOfBirth = '',
                  applicationId,
                  nationality = '',
                  status = '',
                  applicantStatus = '',
                  phoneNumberoffice = '',
                  phoneNumberResidence = '',
                  email = '',
                  mobile = '',
                  countryNameAndCode = 'India: +91',
                  countryCode = '+91',
                  kraMobileNumber = '',
                  kraEmailId = '',
                  emailPersonRelation = '',
                  emailPersonRelationType = '',
                  phonePersonRelation = '',
                  phonePersonRelationType = '',
                } = applicant;
                const defaultPayload = {
                  id,
                  panNo,
                  name,
                  dateOfBirth,
                  applicationId: applicationId as number | null | undefined,
                  nationality,
                  status,
                  phoneNumberoffice,
                  phoneNumberResidence,
                  email,
                  mobile,
                  countryNameAndCode: applicant.countryNameAndCode
                    ? applicant.countryNameAndCode
                    : 'India: +91',
                  countryCode: applicant.countryCode ? applicant.countryCode : '+91',
                  address: {
                    nationality: null,
                    status: null,
                    applicantStatus,
                    permanent: getAddressFields('permanent'),
                  },
                  kraMobileNumber,
                  kraEmailId,
                  emailPersonRelationType: emailPersonRelation
                    ? getEmailPhonePersonRelationType(emailPersonRelation)
                      ? emailPersonRelation
                      : 'Others'
                    : '',
                  emailPersonRelation: getEmailPhonePersonRelationType(emailPersonRelation)
                    ? ''
                    : emailPersonRelation,
                  phonePersonRelationType: phonePersonRelation
                    ? getEmailPhonePersonRelationType(phonePersonRelation)
                      ? phonePersonRelation
                      : 'Others'
                    : '',
                  phonePersonRelation: getEmailPhonePersonRelationType(phonePersonRelation)
                    ? ''
                    : phonePersonRelation,
                };
                if (
                  `${applicant.applicantStatus ?? ''}`.toLowerCase() === applicantStatusValueMap.individual
                ) {
                  return {
                    ...defaultPayload,
                    address: {
                      ...defaultPayload.address,
                      correspondence: getAddressFields('correspondence'),
                    },
                  };
                }
                return {
                  ...defaultPayload,
                  address: {
                    ...defaultPayload.address,
                    overseasAddress: getAddressFields('overseas'),
                  },
                };
              })
              : exisitingApplicants?.map((applicant) => {
                const {
                  id = "",
                  panNo = '',
                  name = '',
                  dateOfBirth = '',
                  applicationId,
                  phoneNumberoffice = '',
                  phoneNumberResidence = '',
                  email = '',
                  mobile = '',
                  countryNameAndCode = 'India: +91',
                  countryCode = '+91',
                  kraMobileNumber = '',
                  kraEmailId = '',
                  emailPersonRelation = '',
                  emailPersonRelationType = '',
                  phonePersonRelation = '',
                  phonePersonRelationType = '',
                  status = "",
                  applicantStatus = ""
                } = applicant;
                const correspondence = getAddressData('correspondence', applicant.addresses);
                const permanent = getAddressData('permanent', applicant.addresses);
                const overseas = getAddressData('overseas', applicant.addresses);
                const isStatusIndividual = `${applicantStatus ?? ''}`.toLowerCase() === applicantStatusValueMap.individual

                const defaultPayload = {
                  id,
                  panNo,
                  name,
                  dateOfBirth,
                  applicationId: applicationId as number | null | undefined,
                  phoneNumberoffice,
                  phoneNumberResidence,
                  email,
                  mobile,
                  countryNameAndCode: applicant.countryNameAndCode
                    ? applicant.countryNameAndCode
                    : 'India: +91',
                  countryCode: applicant.countryCode ? applicant.countryCode : '+91',
                  address: {
                    nationality: applicant.nationality,
                    status: applicant.status,
                    applicantStatus: applicant.applicantStatus,
                  },
                  kraMobileNumber,
                  kraEmailId,
                  emailPersonRelationType: emailPersonRelation
                    ? getEmailPhonePersonRelationType(emailPersonRelation)
                      ? emailPersonRelation
                      : 'Others'
                    : '',
                  emailPersonRelation: getEmailPhonePersonRelationType(emailPersonRelation)
                    ? ''
                    : emailPersonRelation,
                  phonePersonRelationType: phonePersonRelation
                    ? getEmailPhonePersonRelationType(phonePersonRelation)
                      ? phonePersonRelation
                      : 'Others'
                    : '',
                  phonePersonRelation: getEmailPhonePersonRelationType(phonePersonRelation)
                    ? ''
                    : phonePersonRelation,
                };
                const permanentAddressPayload =
                  `${applicant.applicantStatus ?? ''}`.toLowerCase() === applicantStatusValueMap.individual
                    ? correspondence.permanentAddressSameAsCorresponding
                      ? defaultPayload
                      : {
                        ...defaultPayload,
                        address: {
                          ...defaultPayload.address,
                          permanent: {
                            ...permanent,
                            country: permanent.country
                              ? permanent.country.toUpperCase()
                              : 'INDIA',
                          },
                        },
                      }
                    : overseas.permanentAddressSameAsCorresponding
                      ? defaultPayload
                      : {
                        ...defaultPayload,
                        address: {
                          ...defaultPayload.address,
                          permanent: {
                            ...permanent,
                            country: !isStatusIndividual ?
                              'INDIA' :
                              permanent.country
                                ? permanent.country.toUpperCase()
                                : 'INDIA',
                          },
                        },
                      };
                return `${applicant.applicantStatus ?? ''}`.toLowerCase() === applicantStatusValueMap.individual
                  ? {
                    ...permanentAddressPayload,
                    address: {
                      ...permanentAddressPayload.address,
                      correspondence: {
                        ...correspondence,
                        country: correspondence.country
                          ? correspondence.country.toUpperCase()
                          : 'INDIA',
                      },
                    },
                  }
                  : {
                    ...permanentAddressPayload,
                    address: {
                      ...permanentAddressPayload.address,
                      overseas: {
                        ...overseas,
                        country: overseas.country ? overseas.country.toUpperCase() : '',
                      },
                    },
                  };
              }),
          countryDropdown: nationalitiesMdmsMasters.countries.map((list) => list.name),
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  const handleEditKycClick = async ({
    applicationId,
    applicantId,
    panNo
  }: {
    applicationId: number | null | undefined;
    applicantId: string;
    panNo: string;
  }) => {
    try {
      setEditKycLoading(true)

      const payload = {
        applicationId: Number(applicationId ?? ""),
        applicantId: Number(applicantId ?? ""),
        panNo
      }

      const response = await (dispatch(getDataForKycModification(payload)) as unknown as Promise<GetDataForKycModificationResponseBody>)

      if (response) {
        setKycData({
          ...(response?.kycDetails ?? {}),
          isNameChecked: false,
          isEmailChecked: false,
          isMobileChecked: false,
          isAddressChecked: false
        })

        setKycEditPopupOpen(true)
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setEditKycLoading(false)
    }
  }

  const handleKycEditPopupClose = () => {
    setKycEditPopupOpen(false)
    setSelectedApplicantId(null)
  }

  const handleKycEditSubmit = async () => {
    try {

      if (!formikRef.current) return

      setKycLinkLoading(true)

      const { values } = formikRef.current

      const currentApplicantData = (values?.applicants ?? []).find((obj) => Number(obj?.id ?? "") === selectedApplicantId)

      const payload = {
        panNo: currentApplicantData?.panNo ?? "",
        emailId: currentApplicantData?.email ?? "",
        investorName: currentApplicantData?.name ?? "",
        isNameChange: kycData?.isNameChecked ? "1" : "0",
        isEmailChange: kycData?.isEmailChecked ? "1" : "0",
        isMobileChange: kycData?.isMobileChecked ? "1" : "0",
        isAddressChange: kycData?.isAddressChecked ? "1" : "0",
        dob: currentApplicantData?.dateOfBirth ?? "",
        applicationId: Number(currentApplicantData?.applicationId ?? "")
      }

      const response = (await dispatch(MfuKycModification(payload)) as unknown as MfuKycModificationResponseBody);

      if (response) {
        setKycEditPopupOpen(false)
        setKycLinkData(response)
        setKycLinkPopupOpen(true)
      }
    } catch (error) {
      console.log("Error: ", error)
    } finally {
      setKycLinkLoading(false)
    }
  }

  const handleCloseKycLinkPopup = () => {
    setKycLinkPopupOpen(false)

    history.push('/applications')
  }

  return (
    <>
      <Formik
        innerRef={formikRef}
        initialValues={contactDetails}
        onSubmit={handleSubmit}
        validate={(values: Values) => {
          try {
            validateYupSchema(values, contactDetailsSchema(currencyCode), true, values);
          } catch (e) {
            return yupToFormErrors(e);
          }
        }}
        enableReinitialize={true}>
        {({ handleSubmit, values, setValues, handleChange, setFieldValue }) => (
          <Grid
            container
            columnSpacing={3}
            rowSpacing={0.5}
            // rowSpacing={1}
            // columnSpacing={5}
            // sx={{
            //   width: '100%',
            //   ml: 0,
            //   '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
            // }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            <ApplicantDetails
              values={values}
              handleChange={handleChange}
              setValues={setValues}
              mdmsCountriesList={mdmsCountriesList}
              application={application}
              setSelectedApplicantId={setSelectedApplicantId}
              handleEditKycClick={handleEditKycClick}
              isEditKycLoading={isEditKycLoading}
            />
            <Grid item xs={12} my={1} />
            {!!application?.applicants.length && (
              <ProceedSaveLater
                saveLater={() => setFieldValue('saveType', 'save for later')}
                saveAndProceed={() => setFieldValue('saveType', 'save and proceed')}
                loader={loading}
                clickedButton={values.saveType}
                saveButtonText="Continue"
                showEndIcon={false}
              />
            )}
          </Grid>
        )}
      </Formik>
      <KycEditPopup
        open={isKycEditPopupOpen}
        kycData={kycData}
        setKycData={setKycData}
        onClose={handleKycEditPopupClose}
        onSubmit={handleKycEditSubmit}
        isSubmitBtnLoading={kycLinkLoading}
      />
      <KycInfoPopup
        open={kycLinkPopupOpen}
        title={kycLinkData?.message ?? ""}
        subtitle={kycLinkData?.kycOnboardingURL ?? ""}
        copyText={kycLinkData?.kycOnboardingURL ?? ""}
        submitButtonLabel="Okay"
        onSubmitBtnClick={handleCloseKycLinkPopup}
      />
    </>
  );
}
